var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"transition"},[_c('v-lazy-image',{attrs:{"sizes":_vm.sizes,"src":_vm.src,"srcset":_vm.srcset},on:{"load":function($event){_vm.visible = true}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }